// ISO 4217 Currency Dataset
// Comprehensive list of currencies for Sudan marketplace

export const CURRENCIES = [
  // ==================== AFRICA ====================
  // East Africa
  { code: "SDG", region: "africa" }, // Sudan
  { code: "SSP", region: "africa" }, // South Sudan
  { code: "KES", region: "africa" }, // Kenya
  { code: "UGX", region: "africa" }, // Uganda
  { code: "TZS", region: "africa" }, // Tanzania
  { code: "ETB", region: "africa" }, // Ethiopia
  { code: "ERN", region: "africa" }, // Eritrea
  { code: "DJF", region: "africa" }, // Djibouti
  { code: "SOS", region: "africa" }, // Somalia
  { code: "RWF", region: "africa" }, // Rwanda
  { code: "BIF", region: "africa" }, // Burundi
  
  // Central Africa
  { code: "CDF", region: "africa" }, // DR Congo
  { code: "XAF", region: "africa" }, // Central Africa CFA (Cameroon, CAR, Chad, Congo, Eq. Guinea, Gabon)
  
  // West Africa
  { code: "XOF", region: "africa" }, // West Africa CFA (Benin, Burkina Faso, Côte d'Ivoire, Guinea-Bissau, Mali, Niger, Senegal, Togo)
  { code: "NGN", region: "africa" }, // Nigeria
  { code: "GHS", region: "africa" }, // Ghana
  { code: "SLL", region: "africa" }, // Sierra Leone
  { code: "LRD", region: "africa" }, // Liberia
  { code: "GMD", region: "africa" }, // Gambia
  { code: "GNF", region: "africa" }, // Guinea
  { code: "CVE", region: "africa" }, // Cape Verde
  { code: "MRU", region: "africa" }, // Mauritania
  
  // North Africa
  { code: "EGP", region: "africa" }, // Egypt
  { code: "LYD", region: "africa" }, // Libya
  { code: "TND", region: "africa" }, // Tunisia
  { code: "DZD", region: "africa" }, // Algeria
  { code: "MAD", region: "africa" }, // Morocco
  
  // Southern Africa
  { code: "ZAR", region: "africa" }, // South Africa
  { code: "ZMW", region: "africa" }, // Zambia
  { code: "MWK", region: "africa" }, // Malawi
  { code: "MZN", region: "africa" }, // Mozambique
  { code: "AOA", region: "africa" }, // Angola
  { code: "BWP", region: "africa" }, // Botswana
  { code: "NAD", region: "africa" }, // Namibia
  { code: "SZL", region: "africa" }, // Eswatini (Swaziland)
  { code: "LSL", region: "africa" }, // Lesotho
  { code: "ZWL", region: "africa" }, // Zimbabwe
  
  // Island Nations
  { code: "MUR", region: "africa" }, // Mauritius
  { code: "SCR", region: "africa" }, // Seychelles
  { code: "KMF", region: "africa" }, // Comoros
  { code: "MGA", region: "africa" }, // Madagascar
  { code: "STN", region: "africa" }, // São Tomé and Príncipe
  
  // ==================== MENA (Middle East & North Africa) ====================
  // Gulf States
  { code: "SAR", region: "mena" }, // Saudi Arabia
  { code: "AED", region: "mena" }, // UAE
  { code: "QAR", region: "mena" }, // Qatar
  { code: "KWD", region: "mena" }, // Kuwait
  { code: "BHD", region: "mena" }, // Bahrain
  { code: "OMR", region: "mena" }, // Oman
  
  // Levant & Iraq
  { code: "JOD", region: "mena" }, // Jordan
  { code: "LBP", region: "mena" }, // Lebanon
  { code: "SYP", region: "mena" }, // Syria
  { code: "IQD", region: "mena" }, // Iraq
  { code: "ILS", region: "mena" }, // Israel
  
  // Other MENA
  { code: "YER", region: "mena" }, // Yemen
  { code: "IRR", region: "mena" }, // Iran
  
  // ==================== GLOBAL ====================
  // Major World Currencies
  { code: "USD", region: "global" }, // United States
  { code: "EUR", region: "global" }, // Eurozone
  { code: "GBP", region: "global" }, // United Kingdom
  { code: "CHF", region: "global" }, // Switzerland
  { code: "JPY", region: "global" }, // Japan
  { code: "CNY", region: "global" }, // China
  { code: "INR", region: "global" }, // India
  { code: "PKR", region: "global" }, // Pakistan
  { code: "BDT", region: "global" }, // Bangladesh
  { code: "TRY", region: "global" }, // Turkey
  { code: "RUB", region: "global" }, // Russia
  { code: "BRL", region: "global" }, // Brazil
  { code: "MXN", region: "global" }, // Mexico
  { code: "CAD", region: "global" }, // Canada
  { code: "AUD", region: "global" }, // Australia
  { code: "NZD", region: "global" }, // New Zealand
  { code: "SGD", region: "global" }, // Singapore
  { code: "HKD", region: "global" }, // Hong Kong
  { code: "KRW", region: "global" }, // South Korea
  { code: "THB", region: "global" }, // Thailand
  { code: "MYR", region: "global" }, // Malaysia
  { code: "IDR", region: "global" }, // Indonesia
  { code: "PHP", region: "global" }, // Philippines
  { code: "VND", region: "global" }, // Vietnam
];

// Get currencies by region
export const getCurrenciesByRegion = (region) => {
  return CURRENCIES.filter(c => c.region === region);
};

// Get all currency codes
export const CURRENCY_CODES = CURRENCIES.map(c => c.code);

// Default currency based on context
export const getDefaultCurrency = () => {
  // For Sudan marketplace, default to SDG
  return "SDG";
};

// Region labels for grouping
export const REGION_LABELS = {
  africa: { en: "Africa", ar: "أفريقيا" },
  mena: { en: "Middle East & North Africa", ar: "الشرق الأوسط وشمال أفريقيا" },
  global: { en: "Global Currencies", ar: "عملات عالمية" }
};
